module.exports = __webpack_public_path__ + "static/me-d0f27132c2cc062e905d501d576a3e1f.jpg";